<!-- Step 4 - customer coordinates -->
<script>
    import {onMount} from 'svelte';
    import { fade } from 'svelte/transition';
    import isLoading from '../stores/loading-store';
    import {reservation, steps} from '../stores/reservation-store';
    import FormNavigation from './event-form-navigation.svelte';
    import RecapTable from './recap-table.svelte';
    import {
        i18n, def,
    } from "svelte-translate";

    const urlParams = new URLSearchParams(window.location.search);
    const conditionsUrl = window.conditionsUrl

    function isPositiveInteger(n) {
        return n >>> 0 === parseFloat(n);
    }

    onMount(async () => {
        isLoading.set(true);
        $steps.previousStep = 3;
        $steps.nextStep = 5;
        isLoading.set(false);

        let f = function() {
            this.classList.add('touched')
        }
        document.querySelectorAll('input')
            .forEach((e) => {
            e.addEventListener('blur', f, false)
            e.addEventListener('keydown', f, false)
        })
        validateForm();
    });

    const validateForm = () => {
        // uses HTML5 native validation, should be extended/improved.
        if (document.getElementById("details-form").checkValidity()) {
            if (!isPositiveInteger($reservation.socks)) {
                $reservation.socks = 0;
            }
            $steps.nextStepAllowed = true;
        } else {
            $steps.nextStepAllowed = false;
        }
    };
</script>

<div out:fade="{{delay: 0, duration: 150 }}" in:fade="{{delay: 500, duration: 200 }}" class="pb-4">
    <form id="details-form" class="Form-container"
        on:invalid={validateForm}
        on:changed={validateForm}
        on:input={validateForm}>

        <div class="Form-split">
            <RecapTable />
        </div>
        <div class="Form-split">

            {#if $reservation.eventType === 'KOparty-Birthday'}
                <div class="Form-section">
                    <div class="Form-label-wrapper">
                        <label for="socks" class="Form-label" use:i18n={"socksCountLabel"}>Socks:</label>
                    </div>
                    <div class="Form-input-wrapper">
                        <input type="number" name="socks" id="socks" bind:value="{$reservation.socks}" required  class="Form-text-input" />
                    </div>
                </div>
            {/if}
        <div class="Form-section">
             <div class="Form-label-wrapper">
        <label for="firstname" class="Form-label" use:i18n={"firstNameLabel"}>First name:</label>
            </div>
             <div class="Form-input-wrapper">
        <input type="text" name="firstname" id="firstname" bind:value="{$reservation.firstName}" required  class="Form-text-input" />
        </div>
        </div>

        <div class="Form-section">
             <div class="Form-label-wrapper">
        <label for="lastname" class="Form-label" use:i18n={"lastNameLabel"}>Last name:</label>
            </div>
                 <div class="Form-input-wrapper">
        <input type="text" name="lastname" id="lastname" bind:value="{$reservation.lastName}" required  class="Form-text-input" />
            </div>
        </div>

        <div class="Form-section">
             <div class="Form-label-wrapper">
        <label for="email" class="Form-label" use:i18n={"emailLabel"}>Email:</label>
            </div>
             <div class="Form-input-wrapper">
        <input type="email" name="email" minlength="5" id="email" bind:value="{$reservation.email}" required  class="Form-text-input" />
            </div>
        </div>

        <div class="Form-section">
             <div class="Form-label-wrapper">
        <label for="phone" class="Form-label" use:i18n={"phoneLabel"}>Mobile phone:</label>
            </div>
             <div class="Form-input-wrapper">
        <input type="tel" minlength="9" pattern="^[0-9-+\s//)]*$" name="phone" id="phone" bind:value="{$reservation.phone}" required  class="Form-text-input" />
            </div>
        </div>

        <div class="Form-section">
             <div class="Form-label-wrapper">
            </div>
             <div class="Form-input-wrapper">
                <input type="checkbox" bind:checked="{$reservation.marketingEmails}" name="marketing" id="marketing" class="Form-checkbox" />
                <label for="marketing" class="Form-label-checkbox Form-label-checkbox--optional" use:i18n={"marketingEmailsLabel"}>Send me marketing emails</label>
            </div>
        </div>

            <div class="Form-section">
                <div class="Form-label-wrapper">
                </div>
                <div class="Form-input-wrapper">
                    <input type="checkbox" bind:checked="{$reservation.conditions}" name="conditions" id="conditions" class="Form-checkbox" required />
                    <label for="conditions" class="Form-label-checkbox"><span use:i18n={"conditionsLabel1"}>I accept the </span><a href="{conditionsUrl}" class="link-standard" target="_blank" use:i18n={"conditionsLabel2"}>general conditions and privacy policy of Kojump</a></label>
                </div>
            </div>
        </div>
    </form>
    <FormNavigation />
</div>

